<div class="online-users">
<div class="online-users-field">Online Total : <strong> {{onlineUsers?.totalUsers}}</strong></div>

<div class="online-users-field pointer" (click)="openOnlineUserList()">CMS :
    <strong>{{onlineUsers?.utmcUsers}}</strong></div>

<div class="online-users-field">Employers : <strong>{{onlineUsers?.employerUsers}}</strong></div>

</div>
